<h5 class="dialog-title fw-bold"
  cdkDrag cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle style="cursor: move;">
  Richiesta di modifica
</h5>
<div class="ps-4 pe-4 pt-2 pb-2" mat-dialog-content>
  <form [formGroup]="form">
    <div class="row g-4">
      <!-- DATA DA -->
      <div class="col-12 col-lg-6">
        <label class="form-label" for="dataDa" [class.required]="isRequired('dataDa')">Data da</label>
        <input type="date" id="dataDa" [formControl]="dataDa" class="form-control" [min]="inizioMeseTimesheet"
          [max]="fineMeseTimesheet" />
        @if((dataDa.errors?.['required'] || dataDa.errors?.['incorrect']) &&
        dataDa.touched) {
        <div class="invalid-feedback">Il campo è obbligatorio</div>
        }
      </div>

      <!-- DATA DA -->
      <div class="col-12 col-lg-6">
        <label class="form-label" for="dataA" [class.required]="isRequired('dataA')">Data a</label>
        <input type="date" id="dataA" [formControl]="dataA" class="form-control" [min]="inizioMeseTimesheet"
          [max]="fineMeseTimesheet" />
        @if((dataA.errors?.['required'] || dataA.errors?.['incorrect']) &&
        dataA.touched) {
        <div class="invalid-feedback">Il campo è obbligatorio</div>
        }
      </div>

      <!-- COMMESSA ERRATA -->
      <div class="col-12">
        <label class="form-label" for="codiceCommessaSorgente"
          [class.required]="isRequired('codiceCommessaSorgente')">Commessa sorgente</label>
        <app-autocomplete [_formControl]="codiceCommessaSorgente" [_list]="commesseErrate" [fullTitle]="true">
        </app-autocomplete>
      </div>

      <!-- COMMESSA CORRETTA -->
      <div class="col-12">
        <label class="form-label" for="codiceCommessaDestinazione"
          [class.required]="isRequired('codiceCommessaDestinazione')">Commessa destinazione</label>
        <app-autocomplete [_formControl]="codiceCommessaDestinazione" [_list]="filteredCommesse" [fullTitle]="true">
        </app-autocomplete>
      </div>
      <!-- INTERVENTO -->
      <div class="col-12">
        <label class="form-label" for="intervento" [class.required]="isRequired('intervento')">
          Intervento
        </label>
        <app-autocomplete [_formControl]="intervento" [_list]="interventiList" _placeholder="Seleziona"
          [fullTitle]="true"></app-autocomplete>
      </div>
      @if (isCommessaTariffa) {
      <!-- RUOLO -->
      <div class="col-12">
        <label class="form-label" for="ruolo" [class.required]="isRequired('ruolo')">
          Ruolo
        </label>
        <select formControlName="ruolo" class="form-select">
          <option [ngValue]="null">-</option>
          <option *ngFor="let item of ruoliList" [ngValue]="item.id">{{item.descrizione}}</option>
        </select>
        @if((ruolo.errors?.['required'] || ruolo.errors?.['incorrect']) && ruolo.touched) {
        <div class="invalid-feedback">Il campo è obbligatorio</div>
        }
      </div>
      }
    </div>

  </form>
</div>
<div mat-dialog-actions class="p-4 d-flex justify-content-end">
  <button (click)="reject()" type="button" class="btn me-4 btn-outline-primary fw-semibold">
    Annulla
  </button>
  <button (click)="confirm()" [disabled]="form.invalid" type="submit" class="btn btn-primary fw-semibold">
    Salva
  </button>
</div>
